import api from "../api/api";
import * as url from "../api/url";

// Post Contact us Api
export const GetPageContent = (route) => {
  return new Promise(async (resolve, reject) => {
    return api
      .get(
        `${url.GET_PAGE_SECTION}?applicationId=D09B54F5-9E22-434A-92D8-0F6E0B5E44D4&url=https://marcel-website-linux-stage.azurewebsites.net${route}`
      )
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};
